export const reloadPage = (): void => {
    globalThis.location.reload();
};
